import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { catchError, map, Observable, throwError } from "rxjs";
import { CompanyClient, ServiceRespose } from "../../shared";

@Injectable({
    providedIn: 'root'
})
export class ClientService{
    http = inject(HttpClient);
    private readonly baseApiUrl = `${environment.userServiceApiBaseUrl}/api/client`;

    addClientDetails(clientDetails: CompanyClient): Observable<CompanyClient>{
        return this.http
            .post<ServiceRespose<CompanyClient>>(`${this.baseApiUrl}`, clientDetails)
            .pipe(
                map((res) => res.data),
                catchError((err)=>throwError(() => new Error(err.message)))
            );
    }

    getClients(userId: string): Observable<CompanyClient[]>{
        return this.http
            .get<ServiceRespose<CompanyClient[]>>(`${this.baseApiUrl}/all/${userId}`)
            .pipe(
                map((res) => res.data),
                catchError((err)=>throwError(() => new Error(err.message)))
            );
    }

    getClientById(clientId: string): Observable<CompanyClient>{
        return this.http
            .get<ServiceRespose<CompanyClient>>(`${this.baseApiUrl}/${clientId}`)
            .pipe(
                map((res) => res.data),
                catchError((err)=>throwError(() => new Error(err.errorMessage)))
            );
    }

    updateClientDetails(clientId: string, clientDetails: CompanyClient): Observable<CompanyClient>{
        return this.http
            .put<ServiceRespose<CompanyClient>>(`${this.baseApiUrl}/${clientId}`, clientDetails)
            .pipe(
                map((res) => res.data),
                catchError((err)=>throwError(() => new Error(err.message)))
            );
    }
}